import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminCustomerJourney = lazy(() => import("@/pages/admin/AdminCustomerJourney"));
import { AdminLayout } from "@/components/admin/AdminLayout";
export const Route = createFileRoute("/admin/journey")({
  component: () => (
    <AdminLayout requiredPermission="view_audit_logs">
      <AdminCustomerJourney />
    </AdminLayout>
  ),
});
